import { styleCategories } from '@/mocks/gallery';

export default function StyleCards() {
  return (
    <section id="styles" className="relative w-full scroll-mt-16 bg-background-100 py-16 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col gap-2">
          <span className="text-sm font-medium uppercase tracking-widest text-primary-400">By Style</span>
          <h2 className="font-heading text-2xl font-bold text-foreground-50 md:text-4xl">按风格浏览</h2>
          <p className="max-w-2xl text-sm text-foreground-300 md:text-base">
            从清新水彩到赛博霓虹，挑一种合你心意的画风，沉浸其中。
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {styleCategories.map((style) => (
            <a
              key={style.id}
              href="#latest"
              className="group relative block overflow-hidden rounded-lg"
            >
              <img
                src={style.image}
                alt={`${style.name}风格的娜美同人插画`}
                title={`${style.name}娜美同人插画分类`}
                className="aspect-[16/10] w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-50/95 via-background-50/30 to-transparent"></div>
              <div className="absolute inset-x-0 bottom-0 p-4 md:p-5">
                <div className="flex items-center justify-between">
                  <div>
                    <h3 className="font-heading text-lg font-bold text-foreground-50">{style.name}</h3>
                    <p className="mt-1 line-clamp-2 text-xs leading-relaxed text-foreground-300 md:text-sm">{style.desc}</p>
                  </div>
                  <span className="flex items-center gap-1 whitespace-nowrap rounded-full bg-primary-500/90 px-3 py-1.5 text-xs font-medium text-background-50">
                    {style.works} 幅
                  </span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}